import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeRefundationActionResponse from "./chargeRefundationActionResponse";
import ChargePartialRefundationActionResponse from "./chargePartialRefundationActionResponse";
import FuelTypeChangeActionResponse from "./fuelTypeChangeActionResponse";
import ChargeDetailAccessActionResponse from "./chargeDetailAccessActionResponse";
import EmailAddressChangeActionResponse from "./emailAddressChangeActionResponse";
import ReceiptSendingActionResponse from "./receiptSendingActionResponse";
import VehicleRegistrationChangeActionResponse from "./vehicleRegistrationChangeActionResponse";
import AnonymizedReceiptDownloadActionResponse from "./anonymizedReceiptDownloadActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePermittedActionsResponse {
  @observable
  @Type(() => ChargeDetailAccessActionResponse)
  chargeDetailAccess!: ChargeDetailAccessActionResponse;

  @observable
  @Type(() => EmailAddressChangeActionResponse)
  emailAddressChange!: EmailAddressChangeActionResponse;

  @observable
  @Type(() => ChargeRefundationActionResponse)
  refundation!: ChargeRefundationActionResponse;

  @observable
  @Type(() => ChargePartialRefundationActionResponse)
  partialRefundation!: ChargePartialRefundationActionResponse;

  @observable
  @Type(() => FuelTypeChangeActionResponse)
  fuelTypeChange!: FuelTypeChangeActionResponse;

  @observable
  @Type(() => ReceiptSendingActionResponse)
  receiptSending!: ReceiptSendingActionResponse;

  @observable
  @Type(() => VehicleRegistrationChangeActionResponse)
  vehicleRegistrationChange!: VehicleRegistrationChangeActionResponse;

  @observable
  @Type(() => AnonymizedReceiptDownloadActionResponse)
  anonymizedReceiptDownload!: AnonymizedReceiptDownloadActionResponse;
}
